var map = {
	"./auroraSuper.js": 54079,
	"./beachSuper.js": 84272,
	"./blue.js": 32822,
	"./bunnySuper.js": 53341,
	"./candySuper.js": 25574,
	"./frogGarden.js": 74325,
	"./galaxySuper.js": 74687,
	"./green.js": 10715,
	"./iceFrost.js": 22029,
	"./neonquestLegendary.js": 82749,
	"./ninjaSuper.js": 70337,
	"./orange.js": 79680,
	"./pink.js": 22310,
	"./purple.js": 67028,
	"./retro8bit.js": 1063,
	"./tealCrystal.js": 93232,
	"./violet.js": 4285,
	"./yellow.js": 63450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30187;